import { Product } from "@app/shared/models/product";
import { Media } from "@app/shared/models/media";
export class ProductLineItem {
  id?: number;
  offer?:string;
  advsavingsvalue?:string;
  advsellvalue?:string;
  assetGroup?:string;
  assetDescr?:string;
  liner?:string;
  callout?:string;
  code?:string;
  compPriceUnit?:string;
  contentUnitUom?:string;
  costDiscountPc?:string;
  costNow?:string;
  costPrice?:string;
  discounttype?:string;
  displayCode?:string;
  extraNotes?:string;
  extraText?:string;
  featureCode?:string;
  fixedDollarAmountEstimate?:string;
  fromSavings?:string;
  grossProfitPc?:string;
  grossprofitwhole?:string;
  ind?:string;
  lmValue?:string;
  logoText?:string;
  media?:Media;
  minSpend?:string;
  netContent?:string;
  packagedOfferDiscountValue?:string;
  previousDateString?:string;
  product?:Product;
  productqty?:number;
  retailDiscount?:string;
  salesIndication?:string;
  savePercent?:string;
  salesPlan?:string;
  savings?:number;
  termType?:string;
  toSavings?:string;
  uom?:string;
  vesselAmount?:number;
  wholesaleAcqCost?:string;
  isHero?:boolean;
  hero?:string;

  //sellstring:string;
  // get sellstring():string{
  //   let str = '';
  //
  //   if(this.sell_first)
  //     str += this.sell_first;
  //
  //   if(this.sell_second)
  //     str += `.${this.sell_second}`;
  //
  //   return str;
  // }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/productLineItem.ts